import React from "react";
import { Footer } from "../Footer";
import { Navbar } from "../Navbar";

const termsData = [
    {
        title: "INTRODUCTION",
        desc: [
            "Thank you for visiting our website. BLUEBERRY TRAVEL DMC (“the Company”) offers this platform as a service to its corporate clients, providing comprehensive information about our travel packages and services. By accessing this site and making a booking, you confirm that you have read, understood, and agreed to comply with the terms and conditions outlined below.",
            "We strongly advise you to read these terms thoroughly to gain a clear understanding of the policies and procedures that govern your selected travel package. These conditions apply to all reservations made through our online platforms.",
            "By using this site, you affirm that you have reached the legal age of majority in your state or province of residence. If you are a minor, you must be using the website under supervision of a parent or guardian.",
            "You agree not to misuse our platform or content in any manner that is illegal or unauthorized. You must not introduce harmful software, viruses, or malicious code.",
            "Any violation of these terms may lead to immediate suspension or termination of access."
        ]
    },
    {
        title: "PRICING",
        desc: [
            "Information on this website is for general purposes only and does not constitute an offer or guarantee. All content, including images, graphics, and materials, is the property of BLUEBERRY TRAVEL DMC and protected under copyright laws.",
            "Prices listed are per person unless stated otherwise and exclude additional costs such as tips, visa fees, insurance, meals, accommodation extras, and any other incidental expenses.",
            "Prices are subject to change without prior notice due to factors beyond our control, including but not limited to currency fluctuations, fuel surcharges, or changes in government policies.",
            "The Company reserves the right to modify or discontinue services at any time without liability."
        ]
    },
    {
        title: "CANCELLATION",
        desc: [
            "Each service has its own cancellation policy depending on the destination and service provider. Guests are required to review and understand the applicable terms before confirming their booking.",
            "No refunds will be issued in case of no-shows, partially used services, or voluntary changes made by the traveler after the commencement of the trip."
        ]
    },
    {
        title: "CANCELLATION PROCEDURES",
        desc: [
            "All cancellation requests must be submitted in writing via email or through the official communication channel used during booking.",
            "The Company will acknowledge the cancellation request and provide details of applicable charges or refunds based on the specific cancellation policy of the service booked."
        ]
    },
    {
        title: "ITINERARY AMENDMENTS",
        desc: [
            "Travel itineraries may be subject to changes due to operational requirements, weather conditions, local regulations, or other unforeseen circumstances.",
            "The Company reserves the right to alter the sequence of activities, substitute services, or make necessary adjustments without prior notice and without liability.",
            "No compensation shall be provided for disruptions caused by force majeure events including natural disasters, political instability, or other events beyond our control."
        ]
    },
    {
        title: "OUR RESPONSIBILITIES",
        desc: [
            "BLUEBERRY TRAVEL DMC acts as an intermediary between clients and service providers such as airlines, hotels, transport operators, and other vendors.",
            "We are not responsible for any loss, injury, delay, or inconvenience caused by third-party providers or external factors beyond our control.",
            "The Company shall not be held liable for any damages arising from the actions or omissions of third-party service providers."
        ]
    },
    {
        title: "YOUR RESPONSIBILITIES",
        desc: [
            "Travelers are responsible for ensuring that all travel documents such as passports, visas, and permits are valid and up to date.",
            "It is the responsibility of the traveler to arrive on time for all scheduled services including flights, transfers, and excursions.",
            "Travelers must behave responsibly and adhere to local laws and regulations. Any misconduct may result in termination of services without refund."
        ]
    },
    {
        title: "HOTEL ACCOMMODATION",
        desc: [
            "Hotel accommodations are subject to availability at the time of booking.",
            "In case the preferred hotel is unavailable, a similar category hotel will be arranged.",
            "Standard hotel check-in and check-out policies apply and must be adhered to by the traveler."
        ]
    },
    {
        title: "TRAVEL DOCUMENTS",
        desc: [
            "It is the sole responsibility of the traveler to ensure possession of all required travel documents.",
            "The Company shall not be liable for any losses or expenses incurred due to incorrect or missing documentation."
        ]
    },
    {
        title: "WEBSITE USAGE RESTRICTIONS",
        desc: [
            "All content available on this website is the property of BLUEBERRY TRAVEL DMC and may not be reproduced, distributed, or used without prior written consent.",
            "Unauthorized use of the website or its content may result in legal action."
        ]
    },
    {
        title: "LINKS TO THIRD PARTY SITES",
        desc: [
            "This website may contain links to third-party websites for convenience.",
            "The Company does not control or endorse the content of these external sites and is not responsible for their accuracy or reliability."
        ]
    },
    {
        title: "LIMITATION OF LIABILITY & INDEMNITY",
        desc: [
            "The liability of the Company is limited to the amount paid by the client for the services booked.",
            "The Company shall not be responsible for any indirect, incidental, or consequential damages.",
            "Clients agree to indemnify and hold harmless the Company from any claims arising from misuse of services."
        ]
    },
    {
        title: "DATA PRIVACY & PROTECTION",
        desc: [
            "All personal data collected will be treated confidentially and used only for the purpose of providing services.",
            "The Company will not share personal information with third parties without consent unless required by law."
        ]
    },
    {
        title: "GOVERNING LAW AND JURISDICTION",
        desc: [
            "These terms and conditions shall be governed by and interpreted in accordance with the laws of the United Arab Emirates.",
            "Any disputes arising shall be subject to the exclusive jurisdiction of the courts in the UAE."
        ]
    },
    {
        title: "SEVERABILITY",
        desc: [
            "If any provision of these terms is found to be invalid or unenforceable, the remaining provisions shall remain in full force and effect."
        ]
    },
    {
        title: "ENTIRE AGREEMENT",
        desc: [
            "These terms and conditions constitute the entire agreement between the client and BLUEBERRY TRAVEL DMC and supersede any prior agreements or understandings."
        ]
    }
];

const TermsAndConditions = () => {
    return (
        <>
        <Navbar/>
        <div className="standard-padding">
            <h1 className="heading mb-4 text-center">Terms And Conditions</h1>

            {termsData.map((section, index) => (
                <div key={index} className="mb-4">
                    <h2 className="subheading">{section.title}</h2>

                    {section.desc.map((para, i) => (
                        <p key={i} className="desc mb-2">
                            {para}
                        </p>
                    ))}
                </div>
            ))}
        </div>
        <Footer/>
        </>
    );
};

export default TermsAndConditions;